export default {
    SalesOrderEntry: {
        Basic: 'Account Information of third-party orders',
        order: 'Third party Order No.',
        time: 'Ordering time of third-party order',
        channel: 'Sales Channel',
        store: 'Store',
        employee: 'Select a sales employee',
        select: 'Please select',
        sales: 'Please Select a store first',
        pickup: 'Select a pickup store',
        Notes: 'Customer Comments',
        Buyer: 'Buyer and receipt information',
        method: 'Pickup method',
        nickname: "Buyer's nickname",
        Consignee: 'Full Name',
        phone: "Buyer's phone number",
        mobile: 'Phone Number',
        Shipping: 'Shipping address',
        address: 'Please Enter',
        comments: 'Buyer comments',
        information: 'Payment information',
        Payment: 'Payment method',
        amount: 'Payment amount',
        Does: 'Does the payment amount include freight',
        enter: 'Please enter the freight amount',
        status: 'Payment status',
        ayment: 'Payment time',
        Offer: 'Offer information',
        platform: 'Tripartite platform discounts',
        Triple: 'Triple platform discount amount',
        commitment: 'Discount commitment',
        The: 'The preferential amount borne by the third-party platform',
        bears: 'Merchant bears the discount amount',
        Product: 'Product Information',
        delete: 'Delete in Batches',
        ordinary: 'Add Product',
        package: 'Add Sales Kit',
        receivable: 'Total order receivable amount',
        discount: 'Total discount amount',
        freight: 'Total freight amount',
        actually: 'Total amount actually paid by the buyer',
        cost: 'Total cost of goods',
        goods: 'Add ordinary goods',
        Add: 'Add Sales Kit',
        Please: 'Please select a Country/State',
        detailed: 'Please enter a detailed address',
        PriceSearchResults: 'Price search results',
        SearchAgain: 'Search for price again',
        Searchprice: 'Search for price',
        SearchpriceInfo: 'Search For Price Info',
        form: {
            channel: 'Please select a channel',
            store: 'Please select a store',
            order: 'Please enter a Customer Order No.',
            ordering: 'Please select the ordering time of the third-party order',
            type: 'Please select an order type',
            nickname: "Please enter the buyer's nickname",
            consignee: 'Please enter the name of the consignee',
            number: 'Please enter your phone number',
            payment: 'Please select a payment method',
            amount: 'Please enter the payment amount',
            Single: 'The sales unit price of third-party platforms cannot be empty',
            Outer: 'please enter the shared total price of the three-party platform',
            Trans: 'please enter the postage',
            Qty: 'Product quantity cannot be 0 or empty',
            status: 'Please select a payment status',
            time: 'Please select a payment time',
            pickup: 'Please select a pickup store',
            delivery: 'Please select a delivery method',
            obtained: 'Successfully obtained order information',
            sure: 'Are you sure to batch delete SKUs?',
            succeeded: 'Deletion succeeded',
            want: 'Are you sure you want to delete the SKU?',
            cannot: 'The payment time cannot be earlier than the order placing time',
            total: 'The total sales price of the third-party platform needs to be equal to the payment amount!',
            Submitted: 'Submitted successfully',
        }
    }
};
